// Curated 12 quick-nav categories with hand-picked unique representative
// images pulled from apps/web/public/product-images/. Each `slug` is a real
// folder under public/product-images so /category/:slug resolves to real SKUs.

export const QUICK_CATEGORIES = [
  {
    slug: "endodontics",
    name: "Endodontics",
    image: "/product-images/endodontics/3m-espe-cavit-g-temporary-filling-material.jpg",
  },
  {
    slug: "orthodontics",
    name: "Orthodontics",
    image: "/product-images/orthodontics/3m-unitek-clarity-ultra-self-ligating-brackets-022-5x5.jpg",
  },
  {
    slug: "prosthodontics",
    name: "Prosthodontics",
    image: "/product-images/prosthodontics/3m-espe-impregum-soft-hand-mix-medium-body-refill.jpg",
  },
  {
    slug: "implantology",
    name: "Implantology",
    image: "/product-images/implantology/adin-closefit-np-2mm-hex-driver-short-np0006.jpg",
  },
  {
    slug: "oral-surgery",
    name: "Oral Surgery",
    image: "/product-images/oral-surgery/abbott-kenacort-40mg-injection-pack-of-36.jpg",
  },
  {
    slug: "periodontics",
    name: "Periodontics",
    image: "/product-images/periodontics/angelus-interlig-single-patient-strip-pack-of-4.jpg",
  },
  {
    slug: "paedodontics",
    name: "Paedodontics",
    image: "/product-images/paedodontics/3m-espe-pediatric-strip-crown-forms.jpg",
  },
  {
    slug: "dental-equipment",
    name: "Dental Equipment",
    image: "/product-images/dental-equipment/3shape-trios-5-intraoral-scanner.jpg",
  },
  {
    slug: "hand-pieces",
    name: "Hand Pieces",
    image: "/product-images/hand-pieces/apple-airotor-handpiece.jpg",
  },
  {
    slug: "instruments",
    name: "Instruments",
    image: "/product-images/instruments/american-eagle-anterior-scaler-jacquette-3-u5-resin-handle.jpg",
  },
  {
    slug: "impression-material",
    name: "Impression Material",
    image: "/product-images/impression-material/3m-espe-imprint-bite-registration-material-vps.jpg",
  },
  {
    slug: "basic-dental-products",
    name: "Basic Dental",
    image: "/product-images/basic-dental-products/3m-9004in-particulate-respirator-pack-of-50.jpg",
  },
];

export const PLACEHOLDER_CATEGORY_IMAGE =
  "/product-images/hot-selling/3m-espe-cavit-g-temporary-filling-material.jpg";
